import { render, staticRenderFns } from "./AssignmentCourse.vue?vue&type=template&id=2abcff6a&scoped=true&"
import script from "./AssignmentCourse.vue?vue&type=script&lang=js&"
export * from "./AssignmentCourse.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentCourse.vue?vue&type=style&index=0&id=2abcff6a&prod&scoped=true&lang=css&"
import style1 from "./AssignmentCourse.vue?vue&type=style&index=1&id=2abcff6a&prod&scoped=true&lang=css&"
import style2 from "./AssignmentCourse.vue?vue&type=style&index=2&id=2abcff6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abcff6a",
  null
  
)

export default component.exports